import { createPlayer } from '@videojs/react';
import { HlsVideo } from '@videojs/react/media/hls-video';
import { VideoSkin, Video, videoFeatures } from '@videojs/react/video';
import '@videojs/react/video/skin.css';

const Player = createPlayer({ features: videoFeatures });

export const VideoPlayer = ({ src, type, width, height, autoPlay = true }) => {
  const MediaComponent = type === 'application/x-mpegURL' ? HlsVideo : Video;

  return (
    <Player.Provider>
      <VideoSkin 
          style={{ width, height }}>
        <MediaComponent src={src} playsInline autoPlay={autoPlay}>
          {type ? <source src={src} type={type} /> : null}
        </MediaComponent>
      </VideoSkin>
    </Player.Provider>
  );
}
